import { IconCheckDefault } from '@iwoca/icons';
import { Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { ContactFooter } from './ContactFooter';

export const Sidebar = () => {
    return (
        <div className="h-full overflow-hidden bg-primary-20 p-0">
            <div className="flex flex-col gap-l p-3xl">
                <Text className="text-3xl font-med text-structure-100">
                    <FormattedMessage
                        id="_.credit_card.sidebar.title"
                        defaultMessage="Get your iwoca credit card today"
                    />
                </Text>

                <div className="text-m text-structure-100">
                    <ul className="flex flex-col gap-m">
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.cashback"
                                defaultMessage="1% cashback on every transaction"
                            />
                        </li>
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.virtual_card"
                                defaultMessage="Instant start with a virtual card"
                            />
                        </li>
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.no_forex"
                                defaultMessage="No foreign exchange fees when spending abroad"
                            />
                        </li>
                        <li className="flex flex-row gap-s">
                            <IconCheckDefault className="my-auto text-success-mid" />
                            <FormattedMessage
                                id="_.credit_card.sidebar.highlight.mobile_app"
                                defaultMessage="Mobile app to manage everything"
                            />
                        </li>
                    </ul>
                </div>
                <div className="hidden min-m:block">
                    <ContactFooter />
                </div>
            </div>
        </div>
    );
};
